import React from 'react';
import {IonButton, IonIcon, IonSpinner} from "@ionic/react";
import classNames from "classnames";


export interface ActionButtonProps {
  disabled?: boolean;
  color?: string;
  onClick: () => void;
  loading: boolean;
  children: any;
  leftIcon?: any;
  rightIcon?: any;
  slot?: string;
  className?: string,
  size?: "default" | "large" | "small" | undefined;
  expand?: "block" | "full" | undefined;
  fill?: "clear" | "default" | "outline" | "solid";
}

const ActionButton: React.FC<ActionButtonProps> = (props) => {
  const args: any = {
    disabled: props.disabled || props.loading,
  };

  if (props.slot)
    args.slot = props.slot;

  return (
    <IonButton
      color={props.color}
      onClick={props.onClick}
      className={classNames(props.className)}
      size={props.size}
      expand={props.expand}
      fill={props.fill}
      {...args}
    >
      {
        props.loading ?
          <IonSpinner slot={'start'} name={'dots'} className="mr-2"/> :
          <>
           {props.leftIcon && <IonIcon slot={'start'} icon={props.leftIcon}/>}
           {props.children}
           {props.rightIcon && <IonIcon slot={'end'} icon={props.rightIcon}/>}
          </>
      }      
    </IonButton>
  );
}

export default ActionButton;
